import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthFacade } from '@mkp/auth/util';
import { SplashscreenService } from '@mkp/shared/util-splashscreen';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  private readonly auth = inject(AuthFacade);
  private readonly splashscreen = inject(SplashscreenService);

  ngOnInit() {
    this.splashscreen.show();
    this.auth.logout();
  }
}
